import { createSelectorWithProps, createSingleEntityStore } from '@recruitee/ngrx';

import { EntityStoreKey, FeatureFlag, FeatureFlagsMap } from '../types';

const { actions, selectors, reducer, namespace } = createSingleEntityStore<FeatureFlagsMap>()(
  EntityStoreKey.featureFlags,
  {
    customActions: adapter => ({
      init: (state, payload: FeatureFlagsMap) => adapter.save(state, payload),
    }),
  },
);

const FeatureFlagSelectors = {
  ...selectors,
  featureEnabled: createSelectorWithProps(
    selectors.data,
    (featureFlagsMap: FeatureFlagsMap, feature: FeatureFlag) => featureFlagsMap[feature],
  ),
};

export {
  actions as FeatureFlagEntityActions,
  reducer as FeatureFlagReducer,
  namespace as FeatureFlagNamespace,
  FeatureFlagSelectors,
};
